import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
    _requestId: null,
};

const getJobsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_JOBS_START: {
            const { requestId } = action.payload || {};
            return { ...state, loading: true, data: null, error: null, _requestId: requestId };
        }

        case types.GET_JOBS_SUCCESS: {
            const { data, requestId } = action.payload || {};
            if (requestId !== state._requestId) return state;
            return { ...state, loading: false, data, error: null };
        }

        case types.GET_JOBS_ERROR: {
            const { requestId } = action.payload || {};
            if (requestId && requestId !== state._requestId) return state;
            return { ...state, loading: false, error: action.payload?.message || action.payload };
        }

        default:
            return state;
    }
};

export default getJobsReducer;
